export const SET_PROJECT = 'SET_PROJECT';
export const SET_DETAILED_PROJECT_LOADING = 'SET_DETAILED_PROJECT_LOADING';
export const SET_PROJECTS = 'SET_PROJECTS';
export const SET_PROJECT_STATUS = 'SET_PROJECT_STATUS';
export const CLEAR_PROJECT = 'CLEAR_PROJECT';
export const CLEAR_PROJECTS = 'CLEAR_PROJECTS';
export const SET_PROJECT_LIST_OPTIONS = 'SET_PROJECT_LIST_OPTIONS';
export const SET_TEST_TYPES = 'SET_TEST_TYPES';
export const SET_TEST_CARDS = 'SET_TEST_CARDS';
export const CLEAR_TEST_CARDS = 'CLEAR_TEST_CARDS';
export const SET_PANORAMIC_DATA = 'SET_PANORAMIC_DATA';
export const SET_PORTS_TO_SCORE = 'SET_PORTS_TO_SCORE';
export const CLEAR_PORTS_TO_SCORE = 'CLEAR_PORTS_TO_SCORE';
export const SET_CONFIGURATION_CLOUD_ASSETS = 'SET_CONFIGURATION_CLOUD_ASSETS';
export const SET_CONFIGURATION_BUCKET_ASSETS = 'SET_CONFIGURATION_BUCKET_ASSETS';
export const SET_CONFIGURATION_SERVICES_ASSETS = 'SET_CONFIGURATION_SERVICES_ASSETS';
export const SET_CONFIGURATION_SERVICES_COMPLIANCE_OPTIONS = 'SET_CONFIGURATION_SERVICES_COMPLIANCE_OPTIONS';
export const SET_SERVICES_ASSETS_LIST_OPTIONS = 'SET_SERVICES_ASSETS_LIST_OPTIONS';
export const SET_CLOUD_SERVICES_SECOND_LEVEL_ITEMS = 'SET_CLOUD_SERVICES_SECOND_LEVEL_ITEMS';
export const CLEAR_CLOUD_SERVICES_SECOND_LEVEL_ITEMS = 'CLEAR_CLOUD_SERVICES_SECOND_LEVEL_ITEMS';
export const SET_CLOUD_SERVICES_THIRD_LEVEL_ITEMS = 'SET_CLOUD_SERVICES_THIRD_LEVEL_ITEMS';
export const CLEAR_CLOUD_SERVICES_THIRD_LEVEL_ITEMS = 'CLEAR_CLOUD_SERVICES_THIRD_LEVEL_ITEMS';
export const SET_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS = 'SET_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS';
export const CLEAR_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS = 'CLEAR_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS';
export const SET_CONFIGURATION_SUBDOMAINS = 'SET_CONFIGURATION_SUBDOMAINS';
export const SET_CONFIGURATION_HOSTS = 'SET_CONFIGURATION_HOSTS';
export const SET_CONFIGURATION_CREDENTIALS = 'SET_CONFIGURATION_CREDENTIALS';
export const SET_CONFIGURATION_DOMAINS = 'SET_CONFIGURATION_DOMAINS';
export const SET_CONFIGURATION_DOMAIN_TAGS = 'SET_CONFIGURATION_DOMAIN_TAGS';
export const SET_CONFIGURATION_CLOUD_ACCOUNT_TAGS = 'SET_CONFIGURATION_CLOUD_ACCOUNT_TAGS';
export const SET_CONFIGURATION_SUBDOMAIN_TAGS = 'SET_CONFIGURATION_SUBDOMAIN_TAGS';
export const SET_CONFIGURATION_ORGANIZATION_TAGS = 'SET_CONFIGURATION_ORGANIZATION_TAGS';
export const SET_ORGANIZATIONS_TAGS = 'SET_ORGANIZATIONS_TAGS';
export const SET_TEST_CARDS_PASSWORD_SPRAY = 'SET_TEST_CARDS_PASSWORD_SPRAY';
export const CLEAR_TEST_CARDS_PASSWORD_SPRAY = 'CLEAR_TEST_CARDS_PASSWORD_SPRAY';
export const SET_TEST_CARDS_DOMAINS = 'SET_TEST_CARDS_DOMAINS';
export const SET_HAS_DISCOVERY_FINISHED = 'SET_HAS_DISCOVERY_FINISHED';
export const SET_TEST_CARDS_DOMAINS_LAST_SCANNED_DATE = 'SET_TEST_CARDS_DOMAINS_LAST_SCANNED_DATE';
export const CLEAR_TEST_CARDS_DOMAINS = 'CLEAR_TEST_CARDS_DOMAINS';
export const SET_TEST_CARDS_SUBDOMAINS = 'SET_TEST_CARDS_SUBDOMAINS';
export const SET_TEST_CARDS_CLOUD_ACCOUNTS = 'SET_TEST_CARDS_CLOUD_ACCOUNTS';
export const CLEAR_TEST_CARDS_SUBDOMAINS = 'CLEAR_TEST_CARDS_SUBDOMAINS';
export const SET_TEST_CARDS_HOSTS = 'SET_TEST_CARDS_HOSTS';
export const CLEAR_TEST_CARDS_HOSTS = 'CLEAR_TEST_CARDS_HOSTS';
export const SET_DATA_LOADING = 'SET_DATA_LOADING';
export const SET_PROJECT_LIST_LOADING = 'SET_PROJECT_LIST_LOADING';
export const SET_RISK_SCORE_HISTORY = 'SET_RISK_SCORE_HISTORY';
export const SET_SUBDOMAINS_FOR_TLD = 'SET_SUBDOMAINS_FOR_TLD';
export const SET_EMAILS_FOR_TLD = 'SET_EMAILS_FOR_TLD';
export const SET_HOSTS_FOR_SUBDOMAIN = 'SET_HOSTS_FOR_SUBDOMAIN';
export const SET_LAST_CTC_NODE = 'SET_LAST_CTC_NODE';
export const SET_ADDING_CONFIGURATION_FLAG = 'SET_ADDING_CONFIGURATION_FLAG';
export const CLEAR_ADDING_CONFIGURATION_FLAG = 'CLEAR_ADDING_CONFIGURATION_FLAG';
export const SET_DELETE_CONFIGURATION_LOADING = 'SET_DELETE_CONFIGURATION_LOADING';
export const CLEAR_DELETE_CONFIGURATION_LOADING = 'CLEAR_DELETE_CONFIGURATION_LOADING';
export const SET_AMOUNT_OF_RUNNING_PROJECTS = 'SET_AMOUNT_OF_RUNNING_PROJECTS';
export const CLEAR_AMOUNT_OF_RUNNING_PROJECTS = 'CLEAR_AMOUNT_OF_RUNNING_PROJECTS';
export const SET_CONFIGURATION_CLOUD_ACCOUNTS = 'SET_CONFIGURATION_CLOUD_ACCOUNTS';
export const SET_CONFIGURATION_CLOUD_ACCOUNTS_OPTIONS = 'SET_CONFIGURATION_CLOUD_ACCOUNTS_OPTIONS';
export const SET_ADD_TAGS_INTERVAL_RUNNING = 'SET_ADD_TAGS_INTERVAL_RUNNING';
export const SET_ADD_TAGS_REF_ID = 'SET_ADD_TAGS_REF_ID';
export const CLEAR_ADD_TAGS_REF_ID = 'CLEAR_ADD_TAGS_REF_ID';
export const SET_PROJECTS_REF_ID = 'SET_PROJECTS_REF_ID';
export const CLEAR_PROJECTS_REF_ID = 'CLEAR_PROJECTS_REF_ID';
export const SET_PROJECTS_RUNNING_INTERVAL = 'SET_PROJECTS_RUNNING_INTERVAL';
export const SET_PROJECTS_PROGRESS = 'SET_PROJECTS_PROGRESS';
export const CLEAR_PROJECTS_PROGRESS = 'CLEAR_PROJECTS_PROGRESS';
